import { useQuery } from '@tanstack/react-query'
import { fetchPartnerInternalMarkets } from 'utility/queries/partner'

export const usePartnerMarkets = () =>
	useQuery({
		queryKey: ['partnerMarkets'],
		queryFn: () => fetchPartnerInternalMarkets(),
	})
